import type { OnCreateAppSync } from "vike-vue/types";

export const onCreateApp: OnCreateAppSync = (pageContext): ReturnType<OnCreateAppSync> => {
  const { app, i18n } = pageContext;

  app.use(i18n)
};
